import { PuffLoader } from "react-spinners";
import { svgLinks } from "../../../public/assets/assetLinks.ts";
import { useEffect, useState } from "react";

const Loader = ({ loading }: { loading: boolean }) => {
  const [size, setSize] = useState(80);

  useEffect(() => {
    const updateSize = () => {
      if (window.innerWidth < 1024) {
        setSize(80);
      } else {
        setSize(160);
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);

    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return (
    <div className="h-screen flex items-center justify-center relative">
      <div className="relative">
        <PuffLoader
          color="#fff"
          loading={loading}
          size={size}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        <img
          src={svgLinks.logo2}
          className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] size-10 lg:size-20"
          alt="Logo"
        />
      </div>
    </div>
  );
};

export default Loader;
